// export const DATE_TIME_FORMAT = 'dd MMMM YYYY, hh:mm:ss a'
// export const DATE_FORMAT = 'dd MMMM YYYY'
// export const TIME_FORMAT = 'hh:mm:ss a'

export const DATE_TIME_FORMAT = 'dd MMMM yyyy, hh:mm:ss a'
export const DATE_FORMAT = 'dd MMMM yyyy'
export const TIME_FORMAT = 'hh:mm:ss a'
